exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".divDocumentViewer .tab-content {\n  height: 1200px;\n  border-style: solid;\n  border-width: 1px;\n  border-color: lightgray;\n}\n.divDocumentViewer .tab-pane {\n  height: 1000px;\n  padding: 10px;\n}\n", ""]);

